module.exports = __webpack_public_path__ + "img/pic11.46756dd6.jpg";